import React, { Component } from 'react';
import ColorPicker from './ColorPicker';
import TetherComponent from 'react-tether';
import classnames from 'classnames';
import raf from 'raf';
import debounce from 'lodash/debounce';
import throttle from 'lodash/throttle';
import flipInvert from '../../../utils/flipInvert';

class PopupColorPicker extends Component {
  constructor(props) {
    super(props);
    this.state = {
      animating: false,
      open: false,
      transform: null,
      visible: false,
    };
    this.closeOnOutsideClick = this.closeOnOutsideClick.bind(this);
    this.triggerChange = this.props.debounce
      ? debounce(this.triggerChange, this.props.debounce)
      : throttle(this.triggerChange, this.props.throttle);
    this.triggerSubmit = this.triggerSubmit.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.hex !== this.props.hex ||
      prevProps.customChangeTrigger !== this.props.customChangeTrigger
    ) {
      this.triggerChange();
    }

    if (!prevState.open && this.state.open) {
      raf(() => $(window).on('click', this.closeOnOutsideClick));
    }
    if (prevState.open && !this.state.open) {
      $(window).off('click', this.closeOnOutsideClick);
    }
  }

  componentWillUnmount() {
    $(window).off('click', this.closeOnOutsideClick);
  }

  onPickerKeydown(e) {
    // Enter
    if (e.keyCode === 13) {
      this.triggerSubmit();
      // Esc
    } else if (e.keyCode === 27) {
      this.close();
    }
  }

  triggerChange() {
    $(this.changer || this.trigger).trigger('change');
  }

  triggerSubmit() {
    if (this.props.submitter) {
      $(this.props.submitter).trigger('submit');
      this.close();
    }
  }

  closeOnOutsideClick(e) {
    if (!$.contains(this.picker, e.target)) {
      this.close();
    }
  }

  toggle(e) {
    e.preventDefault();
    this.state.open ? this.close() : this.open();
  }

  open() {
    this.setState(
      {
        open: true,
        visible: false,
      },
      this.invert
    );
  }

  invert() {
    raf(() => {
      const first = this.trigger.getBoundingClientRect();
      const last = this.picker.getBoundingClientRect();
      const { matrix } = flipInvert(first, last);
      this.setState({ transform: matrix }, () => raf(this.animate));
    });
  }

  animate = () => {
    this.setState({
      animating: true,
      visible: true,
      transform: '',
    });
  };

  close() {
    this.setState({
      animating: false,
      open: false,
      visible: false,
    });
  }

  getPickerRef(node) {
    this.picker = node;
  }

  getTriggerRef(node) {
    this.trigger = node;
  }

  getChangerRef(node) {
    this.changer = node;
  }

  render() {
    const {
      attachment,
      children,
      className,
      input,
      onChange,
      swatches,
      pickerClassName,
      showInput,
      style,
      tether,
      ...color
    } = this.props;
    const { animating, open, transform, visible } = this.state;
    const [triggerFn, childrenFn] = children;

    return (
      <div className={className} ref={node => (this.node = node)} style={style}>
        <TetherComponent
          attachment="middle right"
          constraints={[{ to: 'window', attachment: 'together', pin: true }]}
          {...tether}
        >
          {triggerFn({
            ...this.props,
            ...this.state,
            onClick: this.toggle.bind(this),
            getTriggerRef: this.getTriggerRef.bind(this),
            getChangerRef: this.getChangerRef.bind(this),
          })}
          {open && (
            <ColorPicker
              {...color}
              getRef={this.getPickerRef.bind(this)}
              onKeyDown={this.onPickerKeydown.bind(this)}
              onChange={onChange}
              swatches={swatches}
              showInput={showInput}
              className={classnames(
                pickerClassName,
                'layer1 t-origin-top-left',
                {
                  'trans-duration-5 trans-bounce trans-prop-all': animating,
                }
              )}
              style={{
                opacity: animating ? 1.0 : 0.01,
                visibility: visible ? 'visible' : 'hidden',
                transform,
              }}
            >
              {childrenFn}
            </ColorPicker>
          )}
        </TetherComponent>
      </div>
    );
  }
}

export default PopupColorPicker;

PopupColorPicker.defaultProps = {
  swatches: [],
  throttle: 100,
};
